export type QuickFilter =
    | 'rms-accel'
    | 'peak-accel'
    | 'peak-vel'
    | 'rms-vel'
    | 'overall-vib'
    | 'vib-bands'
    | 'voltage'
    | 'temp'
    | 'signal-strength';

export const DefaultQuickFilters: QuickFilter[] = ['peak-accel', 'rms-vel', 'temp'];
